// extracted by mini-css-extract-plugin
export var black = "Text-module--black--28008";
export var blue = "Text-module--blue--24851";
export var blueDark = "Text-module--blue-dark--75510";
export var blueLight = "Text-module--blue-light--922fc";
export var body = "Text-module--body--695ee";
export var bodyNumeric = "Text-module--body-numeric--ec650";
export var bodyNumericSmall = "Text-module--body-numeric-small--36327";
export var bodyNumericXSmall = "Text-module--body-numeric-x-small--3fce0";
export var bodySmall = "Text-module--body-small--07cef";
export var bodyXSmall = "Text-module--body-x-small--f125f";
export var gray = "Text-module--gray--98854";
export var grayDark = "Text-module--gray-dark--f82f3";
export var grayLight = "Text-module--gray-light--d5010";
export var green = "Text-module--green--eaef5";
export var greenGloss = "Text-module--green-gloss--b4698";
export var greenMatte = "Text-module--green-matte--b3f4d";
export var headlineDisplay = "Text-module--headline-display--83d4b";
export var headlineLarge = "Text-module--headline-large--72c84";
export var headlineSection = "Text-module--headline-section--bf625";
export var headlineSmall = "Text-module--headline-small--6b686";
export var hemX = "Text-module--hemX--e7ecc";
export var label = "Text-module--label--5a2f0";
export var red = "Text-module--red--34962";
export var title = "Text-module--title--37133";
export var titleSmall = "Text-module--title-small--bddad";
export var titleXSmall = "Text-module--title-x-small--b3bcd";
export var weight400 = "Text-module--weight400--f1353";
export var weight500 = "Text-module--weight500--020f4";
export var white = "Text-module--white--9a8a9";
export var yellowGloss = "Text-module--yellowGloss--d0606";